import React, { Component } from 'react'
import './TeacherReport.css'
import ReactToPrint, { PrintContextConsumer } from 'react-to-print';

export default class TeacherReport extends Component {
    constructor(props) {
        super(props)
        var today = new Date(),
            date = today.getDate() + '.' + (today.getMonth() + 1) + '.' + today.getFullYear() + ' ' + today.getHours() + ':' + today.getMinutes() + ':' + today.getSeconds();
        this.state = {
            currentDate: date
        }
    }

    OpenReportsPage(reportsPage, reportType) {
        this.props.OpenReportsPage(reportsPage, reportType)
    }
    selectLanguage(language) {
        this.props.selectLanguage(language)
    }

    render() {
        const { TeacherReport, DescriptionTeacher, teacherPhoto } = this.props
        // console.log('TeacherReport', TeacherReport)
        return (
            <div className='ObhodnoiList D_main_header' >
                <header>
                    <i className="fas fa-arrow-left" onClick={() => this.OpenReportsPage(0, 0)}></i>
                    <ReactToPrint content={() => this.componentRef}>
                        <PrintContextConsumer>
                            {({ handlePrint }) => (
                                <i onClick={handlePrint} className="fa fa-print" title="Печать"></i>
                            )}

                        </PrintContextConsumer>
                    </ReactToPrint>
                    {this.props.language === 1 ? <h2>ОБХОДНОЙ ЛИСТ</h2> : this.props.language === 2 ? <h2>ОБХОДНОЙ ЛИСТ</h2> : <h2>Справка о сотруднике</h2>}
                    {/* <div className='Language'>
                        <h4 onClick={() => this.selectLanguage(1)} className={this.props.language === 1 ? 'Lang_Active' : 'Lang'}>Рус</h4>
                        <h4 onClick={() => this.selectLanguage(2)} className={this.props.language === 2 ? 'Lang_Active' : 'Lang'}>Кырг</h4>
                    </div> */}
                </header>
                <div className="A4 TeacherReport" ref={el => (this.componentRef = el)}>
                    <p className='header_date'>{"AVN " + this.state.currentDate}</p>
                    <div className='TeacherReport_A4_header'>
                        <div className='Ava_person'
                            style={{ border: this.props.id_teacher > 0 ? 'none' : '1px solid #2F80ED' }}>
                            {this.props.id_teacher > 0 ?
                                teacherPhoto && teacherPhoto.length > 0 ? <img src={`data:image/jpeg;base64,${teacherPhoto}`} alt='Avatar' /> :
                                    <h5> ФОТО </h5> : null
                            }
                        </div>
                        <div>
                            <h3>{TeacherReport && TeacherReport.length && TeacherReport[1][0].v2}</h3>
                            <h1>Обходной лист</h1>
                            <h1 style={{ color: '#4967A3' }}>{TeacherReport && TeacherReport.length && TeacherReport[0][0].t_fio}</h1>
                        </div>
                    </div>
                    <table>
                        <thead>
                            <tr>
                                <th>№</th>
                                <th>Наименование</th>
                                <th>Отметка о задолженности</th>
                            </tr>
                        </thead>
                        <tbody>
                            <tr >
                                <td>1</td>
                                <td>Библиотека</td>
                                <td>{TeacherReport && TeacherReport.length && TeacherReport[0][0].t_fio_pole1 === true ? 'Есть задолжнность' : 'Задолженности нет'}</td>
                            </tr>
                            <tr >
                                <td>2</td>
                                <td>Материальный бухгалтер</td>
                                <td>{TeacherReport && TeacherReport.length && TeacherReport[0][0].t_fio_pole2 === true ? 'Есть задолжнность' : 'Задолженности нет'}</td>
                            </tr>
                            <tr >
                                <td>3</td>
                                <td>Расчетный бухгалтер</td>
                                <td>{TeacherReport && TeacherReport.length && TeacherReport[0][0].t_fio_pole3 === true ? 'Есть задолжнность' : 'Задолженности нет'}</td>
                            </tr>
                            <tr >
                                <td>4</td>
                                <td>Комендант общежития</td>
                                <td>{TeacherReport && TeacherReport.length && TeacherReport[0][0].t_fio_pole4 === true ? 'Есть задолжнность' : 'Задолженности нет'}</td>
                            </tr>
                            <tr >
                                <td>5</td>
                                <td>Отдел кадров</td>
                                <td>{TeacherReport && TeacherReport.length && TeacherReport[0][0].t_fio_pole5 === true ? 'Есть задолжнность' : 'Задолженности нет'}</td>
                            </tr>
                            <tr >
                                <td>6</td>
                                <td>Кафедра</td>
                                <td>{TeacherReport && TeacherReport.length && TeacherReport[0][0].t_fio_pole6 === true ? 'Есть задолжнность' : 'Задолженности нет'}</td>
                            </tr>
                            <tr >
                                <td>7</td>
                                <td>Отдел АХР</td>
                                <td>{TeacherReport && TeacherReport.length && TeacherReport[0][0].t_fio_pole7 === true ? 'Есть задолжнность' : 'Задолженности нет'}</td>
                            </tr>
                            <tr >
                                <td>8</td>
                                <td>Бухгалтерия</td>
                                <td>{TeacherReport && TeacherReport.length && TeacherReport[0][0].t_fio_pole8 === true ? 'Есть задолжнность' : 'Задолженности нет'}</td>
                            </tr>
                        </tbody>
                    </table>

                    <p style={{ textAlign: 'center' }}>Дата сдачи обходного листа в отдел кадров «_____» __________________202__ г.</p>
                    <p>{`Трудовую книжку получил_____________________${TeacherReport && TeacherReport.length && TeacherReport[0][0].s_t_fio}`}</p>
                    <nav>
                        <p> Отдел кадров _____________________<span>(Ф.И.О.)</span></p>
                        <p>__________________ <span style={{ left: '25%' }}>(Подпись)</span></p>
                        <p>«_____» _______202__ г.</p>
                    </nav>
                    <table>
                        <thead>
                            <tr>
                                <th>Примечание</th>
                            </tr>
                        </thead>
                        <tbody>
                            {DescriptionTeacher && DescriptionTeacher.length ? DescriptionTeacher.map((item, index) => {
                                return (
                                    <tr key={"descr" + index}>
                                        <td style={{ textAlign: 'left' }}>{item.okno_description}</td>
                                    </tr>
                                )
                            }) : <tr>
                                <td></td>
                            </tr>
                            }
                        </tbody>
                    </table>
                </div>

            </div>
        )
    }
}


